import React from "react";
import feature1 from "../../assets/images/feature1.png";
import feature2 from "../../assets/images/feature2.png";

const Features = () => {
  return (
    <div className="py-6 sm:py-20 mx-4 sm:mx-12 flex flex-col-reverse md:flex-row gap-5 sm:gap-10 justify-center">
      <div className="">
        <div className="overflow-hidden rounded-xl">
          <img
            src={feature1}
            className="hover:scale-105 transition-all duration-300"
            alt=""
          />
        </div>
        <p className="opacity-50 max-w-2xl mt-10">
          Aliquet nec ullamcorper sit amet risus nullam. Purus in mollis nunc
          sed id semper risus in. Purus sit amet volutpat consequat mauris nunc
          congue nisi. Pharetra et ultrices neque ornare aenean euismod. Enim
          diam vulputate ut pharetra sit amet aliquam id diam. Ut eu sem integer
          vitae justo.
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h3 className="jost-regular text-xl sm:text-2xl text-primary py-4 uppercase">
          OUR FEATURES
        </h3>
        <h1 className="jost-regular text-3xl sm:text-5xl max-w-xl">
          Find balance & well- <br />
          <span className="italic font-eiko-thin text-primary">
            being today!
          </span>
        </h1>
        <div className="overflow-hidden rounded-xl">
          <img
            src={feature2}
            className="mt-10 hover:scale-105 transition-all duration-300 hidden sm:block"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Features;
